import { __exports as c } from "../../../../../../../_virtual/index4.js";
import { __require as d } from "./constants.js";
var o;
function p() {
  if (o) return c;
  o = 1, Object.defineProperty(c, "__esModule", { value: !0 }), c.sanitizeUrl = void 0;
  var e = d();
  function l(t) {
    return e.relativeFirstCharacters.indexOf(t[0]) > -1;
  }
  function u(t) {
    var i = t.replace(e.ctrlCharactersRegex, "");
    return i.replace(e.htmlEntitiesRegex, function(r, a) {
      return String.fromCharCode(a);
    });
  }
  function n(t) {
    try {
      return decodeURIComponent(t);
    } catch {
      return t;
    }
  }
  function h(t) {
    if (!t)
      return e.BLANK_URL;
    var i, r = n(t);
    do
      r = u(r).replace(e.htmlCtrlEntityRegex, "").replace(e.ctrlCharactersRegex, "").replace(e.whitespaceEscapeCharsRegex, "").trim(), r = n(r), i = r.match(e.ctrlCharactersRegex) || r.match(e.htmlEntitiesRegex) || r.match(e.htmlCtrlEntityRegex) || r.match(e.whitespaceEscapeCharsRegex);
    while (i && i.length > 0);
    var a = r;
    if (!a)
      return e.BLANK_URL;
    if (l(a))
      return a;
    var s = a.match(e.urlSchemeRegex);
    if (!s)
      return a;
    var m = s[0];
    return e.invalidProtocolRegex.test(m) ? e.BLANK_URL : a;
  }
  return c.sanitizeUrl = h, c;
}
export {
  p as __require
};
